module.exports = __webpack_public_path__ + "img/pen.432300be.svg";